import styled from 'styled-components'

export const StyledStatusContainer = styled.div<{ backgroundColor?: string }>(
  (props) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 10px',
    borderRadius: '8px',
    minWidth: '100px',
    backgroundColor: props.backgroundColor || 'transparent'
  })
)
